/** @format */
import angular from 'angular';
import 'js-data';

export const studyRightExpirationRuleDetailsModelModule = 'sis-components.model.studyRightExpirationRuleDetails';
/**
 * Deprecated, use study-right-expiration-rule-details.service.ts
 */
(function () {
    studyRightExpirationRuleDetailsJSDataModel.$inject = ['$http', 'DS'];
    angular
        .module(studyRightExpirationRuleDetailsModelModule, ['js-data'])
        .factory('studyRightExpirationRuleDetailsJSDataModel', studyRightExpirationRuleDetailsJSDataModel);

    function studyRightExpirationRuleDetailsJSDataModel($http, DS) {
        var model = DS.defineResource({
            idAttribute: 'studyRightExpirationRulesUrn',
            name: 'studyRightExpirationRuleDetails',
            endpoint: '/kori/api/study-right-expiration-rules',
        });

        model.lazyGetAll = _.once(function () {
            return $http.get(model.endpoint).then(function (response) {
                model.inject(_.values(response.data));
                return model.getAll();
            });
        });

        return model;
    }
})();
